import React, { useState, useMemo } from "react";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import "jspdf/dist/polyfills.es.js";
import EditableField from "./EditableField";

const useHover = () => {
  const [hovered, setHovered] = useState();

  const eventHandlers = useMemo(
    () => ({
      onMouseOver() {
        setHovered(true);
      },
      onMouseOut() {
        setHovered(false);
      },
    }),
    []
  );
  return [hovered, eventHandlers];
};

const DataMarketingCv = (props) => {
  const [cv, setCV] = useState({
    avatar: {
      default:
        "https://www.sibberhuuske.nl/wp-content/uploads/2016/10/default-avatar.png?fbclid=IwAR3ohCaqwU-59D8GDRjff4TttyYumvDz4PXEL4HflKLYcq5Rh7Zd4xpgB-U",
      value: "https://miro.medium.com/max/3150/2*zISYzTVsntmRtQK2oLEllw.jpeg",
    },
    name: {
      default: "Full Name",
      value: "Stefanija Tenekedjieva",
    },
    title: {
      default: "Proffesional Title",
      value: "Digital Marketer",
    },
    about: {
      default: "About Me",
      value:
        "Fascinated by the power of communication and media.Quick learner.Endlessly curious and keep to know more.",
    },
    inputMail: {
      default: "Email",
      value: "stefanija.tenekedjieva@gmail.com",
    },
    inputPhone: {
      default: "xxxxxx",
      value: "Phone number",
    },
    workBio: {
      default: "Work Experience",
      value: "WORK EXPERIENCE",
    },
    workPosition: {
      default: "Position/Title",
      value: "Digital Marketer",
    },
    workPlace: {
      default: "Company",
      value: "Laika",
    },
    workHistory: {
      default: "Data xxx",
      value: "11/2019 - Present",
    },
    workTask: {
      default: "Place",
      value: "Skopje,Macedonia",
    },
    workTask1: {
      default: "Achievements/Task",
      value: "Achievements/Task",
    },
    workPara: {
      default: "Accomplishment 1",
      value: "° content writing",
    },
    workPara1: {
      default: "Task 1",
      value: "° social media advertising",
    },
    workPara2: {
      default: "Task 2",
      value: "° lead generation",
    },
    workPara3: {
      default: "Task 2",
      value: "° conversion rate optimisation",
    },
    secondTitle: {
      default: "Title",
      value: "SKILLS",
    },
    btnSkill: {
      default: "skill",
      value: "Google Ads",
    },
    btnSkill1: {
      default: "skill",
      value: "Facebook Ads Manager",
    },
    btnSkill2: {
      default: "skill",
      value: "Google Analitics",
    },
    btnSkill3: {
      default: "skill",
      value: "Google Data Studio",
    },
    btnSkill4: {
      default: "skill",
      value: "Wordpress",
    },
    btnSkill5: {
      default: "skill",
      value: "Canva",
    },
    btnSkill6: {
      default: "skill",
      value: "Adobe Premiere",
    },
    btnSkill6: {
      default: "skill",
      value: "Adobe Premiere",
    },
    workPosition1: {
      default: "Position/Title",
      value: "Project coordinator",
    },
    workPlace1: {
      default: "Company",
      value: "Radio MOF",
    },
    workHistory1: {
      default: "Data xxx",
      value: "11/2019 - Present",
    },
    workPara4: {
      default: "Accomplishment 1",
      value:
        "° Editing,writing,planning and reporting for the projects of radio mof",
    },
    workPara5: {
      default: "Task 1",
      value:
        "° Maintaining social media profiles,web content and statistics od wwww.radiomof.mk throught Google Analytics.",
    },
    workPara6: {
      default: "Task 2",
      value: "° Editing and proofreading of content on wwww.radiomof.mk",
    },
    thirdTitle: {
      default: "Title",
      value: "ACHIEVEMENTS",
    },
    thirdPara: {
      default: "Title",
      value:
        "First Award for Professional reporting of the refugee crisis in 2017 by UNHCR and MYLA",
    },
    thirdPara1: {
      default: "Title",
      value:
        "Third award for Best journalist story from the Macedonian Council of Ethics in Media",
    },
    fourthTitle: {
      default: "Title",
      value: "Languages",
    },
    fourthPara: {
      default: "Title",
      value: "English",
    },
    fourthPara1: {
      default: "Title",
      value: "Full Proffesional Profiency",
    },
    workPositionThird: {
      default: "Position/Title",
      value: "Journalist",
    },
    workPlaceThird: {
      default: "Company",
      value: "Radio MOF",
    },
    workHistoryThird: {
      default: "Data xxx",
      value: "11/2017 - 01/2019",
    },
    workParaThird: {
      default: "Accomplishment 1",
      value:
        "° Content writing,planing and reporting for the projects of radio mof",
    },
    workParaThird1: {
      default: "Task 1",
      value: "° Reports and articles for radio shows",
    },
    workParaThird2: {
      default: "Task 2",
      value: "° Hosting training for Civil and Digital Journalism",
    },

    workPositionFourth: {
      default: "Position/Title",
      value: "EDUCATION",
    },
    workPlaceFourth: {
      default: "Company",
      value: "Education",
    },
    workPlaceFourth1: {
      default: "Company",
      value: "Brainster Digital Marketing Academy",
    },
    workHistoryFourth: {
      default: "Data xxx",
      value: "11/2017 - 01/2019",
    },
    workParaFourth: {
      default: "Accomplishment 1",
      value: "° Integrated Marketing Communication",
    },
    workParaFourth1: {
      default: "Task 1",
      value: "° Unpaid & Paid Social Media",
    },
    workParaFourth2: {
      default: "Task 2",
      value: "° Lead Generation",
    },
    workParaFourth3: {
      default: "Task 3",
      value: "° Google Analytics",
    },
    workParaFourth4: {
      default: "Task 4",
      value: "° Segmentation",
    },
    workParaFourth5: {
      default: "Task 5",
      value: "° Funnel Marketing",
    },
    workParaFourth6: {
      default: "Task 6",
      value: "° Sales",
    },
    workParaFourth7: {
      default: "Task 7",
      value: "° Google Ads",
    },
    workParaFourth8: {
      default: "Task 8",
      value: "° Growth Hacking",
    },
    workParaFourth9: {
      default: "Task 9",
      value: "° SEO",
    },
  });

  const downloadPDF = () => {
    const page = document.getElementById("doctopdf");
    page.style.marginTop = "-" + page.offsetHeight * 1.1 + "px";
    html2canvas(page).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      pdf.addImage(imgData, "JPEG", 0, 0);
      pdf.save("datamarketing.pdf");
      props.handleShow(true);
    });
  };

  return (
    <div id="doctopdf" className="DataMarketing">
      <div className="row p-4 border-bottom border-sedondary">
        <div className="col-md-3">
          <EditableField
            cv={cv}
            setCV={setCV}
            field="avatar"
            type="file"
            editMode={props.editMode}
            handleHover={props.handleHover}
          />
        </div>
        <div className="col-md-9">
          <div className="m-0 font-weight-bold">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="name"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="text-info">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="title"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="about"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
        </div>
      </div>
      <div className="row p-4 border-bottom border-sedondary bg-info">
        <div className="col-md-12 ">
          <div className="d-flex justify-content-center text-white">
            <span className="mr-2">
              <i className="fas fa-envelope"></i>
            </span>
            <div className="CVPARA m-0 mr-5">
              <EditableField
                cv={cv}
                setCV={setCV}
                field="inputMail"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </div>
            <span className="mr-2">
              <i className="fas fa-phone"></i>
            </span>
            <div className="CVPARA m-0">
              <EditableField
                cv={cv}
                setCV={setCV}
                field="inputPhone"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row p-4">
        <div className="col-md-1"></div>
        <div className="col-md-5">
          <div className="m-0 text-info font-weight-bold">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workBio"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="text-info font-weight-bold">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="secondTitle"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
        </div>
      </div>
      <div className="row p-4">
        <div className="col-md-1 mt-2">
          <div className="boxes"></div>
        </div>
        <div className="col-md-5">
          <div className="pb-2 font-weight-bold">
            {" "}
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workPosition"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="py-2">
            {" "}
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workPlace"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="d-flex justify-content-between pr-4">
            <div className="CVPARA text-info">
              <small>
                <EditableField
                  cv={cv}
                  setCV={setCV}
                  field="workHistory"
                  editMode={props.editMode}
                  handleHover={props.handleHover}
                />
              </small>
            </div>
            <div className="CVPARA text-info">
              <small>
                <EditableField
                  cv={cv}
                  setCV={setCV}
                  field="workTask"
                  editMode={props.editMode}
                  handleHover={props.handleHover}
                />
              </small>
            </div>
          </div>
          <div className="CVPARA text-info">
            <small>
              <EditableField
                cv={cv}
                setCV={setCV}
                field="workTask1"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </small>
          </div>
          <div className="CVPARA">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workPara"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workPara1"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workPara2"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA ">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workPara3"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
        </div>

        <div className="col-md-6 innerInput">
          <div className="btn btn-info cvBtn m-2 ">
            {" "}
            <EditableField
              cv={cv}
              setCV={setCV}
              field="btnSkill"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="btn btn-info cvBtn m-2">
            {" "}
            <EditableField
              cv={cv}
              setCV={setCV}
              field="btnSkill1"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="btn btn-info cvBtn m-2">
            {" "}
            <EditableField
              cv={cv}
              setCV={setCV}
              field="btnSkill2"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="btn btn-info cvBtn m-2">
            {" "}
            <EditableField
              cv={cv}
              setCV={setCV}
              field="btnSkill3"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="btn btn-info cvBtn m-2">
            {" "}
            <EditableField
              cv={cv}
              setCV={setCV}
              field="btnSkill4"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="btn btn-info cvBtn m-2">
            {" "}
            <EditableField
              cv={cv}
              setCV={setCV}
              field="btnSkill5"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="btn btn-info cvBtn m-2">
            {" "}
            <EditableField
              cv={cv}
              setCV={setCV}
              field="btnSkill6"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
        </div>
      </div>
      <div className="row p-4">
        <div className="col-md-1 mt-2">
          <div className="boxes"></div>
        </div>
        <div className="col-md-5">
          <div className="pb-2 font-weight-bold">
            {" "}
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workPosition1"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="py-2">
            {" "}
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workPlace1"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="d-flex justify-content-between pr-4">
            <div className="CVPARA text-info">
              <small>
                <EditableField
                  cv={cv}
                  setCV={setCV}
                  field="workHistory1"
                  editMode={props.editMode}
                  handleHover={props.handleHover}
                />
              </small>
            </div>
            <div className="CVPARA text-info">
              <small>
                <EditableField
                  cv={cv}
                  setCV={setCV}
                  field="workTask"
                  editMode={props.editMode}
                  handleHover={props.handleHover}
                />
              </small>
            </div>
          </div>
          <div className="CVPARA text-info">
            <small>
              <EditableField
                cv={cv}
                setCV={setCV}
                field="workTask1"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </small>
          </div>
          <div className="CVPARA">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workPara4"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workPara5"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workPara6"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="py-2 text-info font-weight-bold">
            {" "}
            <EditableField
              cv={cv}
              setCV={setCV}
              field="thirdTitle"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="thirdPara"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="thirdPara1"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="py-2 text-info">
            {" "}
            <EditableField
              cv={cv}
              setCV={setCV}
              field="fourthTitle"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="fourthPara"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA text-info">
            <small>
              <EditableField
                cv={cv}
                setCV={setCV}
                field="fourthPara1"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </small>
          </div>
        </div>
      </div>

      <div className="row p-4">
        <div className="col-md-1 mt-2">
          <div className="boxes"></div>
        </div>
        <div className="col-md-5">
          <div className="pb-2 font-weight-bold">
            {" "}
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workPositionThird"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="py-2 font-weight-bold">
            {" "}
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workPlaceThird"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="d-flex justify-content-between pr-4">
            <div className="CVPARA text-info">
              <small>
                <EditableField
                  cv={cv}
                  setCV={setCV}
                  field="workHistory1"
                  editMode={props.editMode}
                  handleHover={props.handleHover}
                />
              </small>
            </div>
            <div className="CVPARA text-info">
              <small>
                <EditableField
                  cv={cv}
                  setCV={setCV}
                  field="workTask"
                  editMode={props.editMode}
                  handleHover={props.handleHover}
                />
              </small>
            </div>
          </div>
          <div className="CVPARA text-info">
            <small>
              <EditableField
                cv={cv}
                setCV={setCV}
                field="workTask1"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </small>
          </div>
          <div className="CVPARA">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workParaThird"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workParaThird1"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workParaThird2"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
        </div>
      </div>

      <div className="row p-4">
        <div className="col-md-1 mt-2">
          <div className="boxes"></div>
        </div>
        <div className="col-md-5">
          <div className="pb-2 font-weight-bold">
            {" "}
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workPositionFourth"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="py-2 font-weight-bold">
            {" "}
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workPlaceFourth"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="py-2">
            {" "}
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workPlaceFourth1"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="d-flex justify-content-between pr-4">
            <div className="CVPARA text-info">
              <small>
                <EditableField
                  cv={cv}
                  setCV={setCV}
                  field="workHistory1"
                  editMode={props.editMode}
                  handleHover={props.handleHover}
                />
              </small>
            </div>
          </div>
          <div className="CVPARA text-info">
            <small>
              <EditableField
                cv={cv}
                setCV={setCV}
                field="workTask1"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </small>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="CVPARA">
                <EditableField
                  cv={cv}
                  setCV={setCV}
                  field="workParaFourth"
                  editMode={props.editMode}
                  handleHover={props.handleHover}
                />
              </div>
              <div className="CVPARA">
                <EditableField
                  cv={cv}
                  setCV={setCV}
                  field="workParaFourth1"
                  editMode={props.editMode}
                  handleHover={props.handleHover}
                />
              </div>
              <div className="CVPARA">
                <EditableField
                  cv={cv}
                  setCV={setCV}
                  field="workParaFourth2"
                  editMode={props.editMode}
                  handleHover={props.handleHover}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="CVPARA">
                <EditableField
                  cv={cv}
                  setCV={setCV}
                  field="workParaFourth3"
                  editMode={props.editMode}
                  handleHover={props.handleHover}
                />
              </div>
              <div className="CVPARA">
                <EditableField
                  cv={cv}
                  setCV={setCV}
                  field="workParaFourth4"
                  editMode={props.editMode}
                  handleHover={props.handleHover}
                />
              </div>
              <div className="CVPARA">
                <EditableField
                  cv={cv}
                  setCV={setCV}
                  field="workParaFourth5"
                  editMode={props.editMode}
                  handleHover={props.handleHover}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-5">
        <div className="col-md-12 text-right innerInput">
          <button
            className="btn buttonHome"
            data-html2canvas-ignore="true"
            onClick={downloadPDF}
          >
            DOWNLOAD
          </button>
        </div>
      </div>
    </div>
  );
};

export default DataMarketingCv;
